export function formatQuick(txt: string, par0: string, par1?: string, par2?: string, par3?: string, par4?: string, par5?: string): string {
    if (typeof par1 !== "string") par1 = "";
    if (typeof par2 !== "string") par2 = "";
    if (typeof par3 !== "string") par3 = "";
    if (typeof par4 !== "string") par4 = "";
    if (typeof par5 !== "string") par5 = "";
    return txt.replace("{0}", par0).replace("{1}", par1).replace("{2}", par2).replace("{3}", par3).replace("{4}", par4).replace("{5}", par5);
}
